let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("VwrtI")).then(() => parcelRequire('hum0N'));